export default "__VITE_ASSET__cd3ab250__"